import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { MARKETPLACE_PATH, V2_MARKETPLACE_PATH } from '../components/shared/constants';

const MarketplaceRoute = [
  <Route
    key={MARKETPLACE_PATH}
    path={MARKETPLACE_PATH}
    props={{
      clientSide: true,
      pageName: MParticlePageName.Marketplace,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/marketplace_page_wrapper'
      ).then(m => cb(null, m.default));
    }}
  />,
  <Route
    key={V2_MARKETPLACE_PATH}
    path={V2_MARKETPLACE_PATH}
    props={{
      clientSide: true,
      v2Marketplace: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/marketplace_page_wrapper'
      ).then(m => cb(null, m.default));
    }}
  />,
];

export default MarketplaceRoute;
